/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { createBrowserHistory } from 'history';
import { getNewTokenAsync } from '../../features/auth/redux/actions';
import { getUrls } from '../constants';

const history = createBrowserHistory();

export const setupInterceptors = store => {
  axios.interceptors.request.use(config => {
    const { session } = store.getState();
    const token = session.access_token;

    // Fallback path: if the FE has a token in Redux (e.g. code-grant flow), continue attaching it.
    // Cookie-only path: access_token is null, so the browser sends the HttpOnly cookie instead.
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }, error => Promise.reject(error));

  axios.interceptors.response.use(response => response, async error => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry && !originalRequest.headers['skip-refresh']) {
      originalRequest._retry = true;

      try {
        await store.dispatch(getNewTokenAsync());
        // Retry the original request with the new cookie
        return axios(originalRequest);
      } catch (refreshError) {
        // Refresh failed — already logged out by getNewTokenAsync
        return Promise.reject(refreshError);
      }
    }

    if (error.response && error.response.status > 299
      && ![400, 401, 403, 404, 409].includes(error.response.status)
      && !error.response.config.url.includes(getUrls('heartbeat', 'status').replace('{robotId}', ''))
      && !error.response.config.url.includes('scripts/convert')) {
      history.push('/error');
      return Promise.reject(error);
    }

    return Promise.reject(error);
  });
};
